const walking_alone = `Yksin kävely yöllä Suomessa on yleensä turvallista.
Suomessa ihmiset ovat yleensä ystävällisiä ja avuliaita, ja maa tunnetaan turvallisena kaikille.
Kadut ovat hyvin valaistuja, eikä vaaratilanteita ole paljon.
Poliisi on aina valmis auttamaan, jos joku sitä tarvitsee, mikä voi saada ihmiset tuntemaan olonsa turvallisemmaksi yöllä ollessaan ulkona.
Monet ihmiset, mukaan lukien opiskelijat ja työntekijät, kävelevät yksin öisin ilman ongelmia.
He tietävät, että he voivat luottaa ympärillään oleviin ihmisiin ja tuntea olonsa mukavaksi kävellä yksin.
Kaiken kaikkiaan Suomi on turvallinen paikka, ja ihmiset voivat tuntea olonsa mukavaksi yksin kävellessä yöllä.
On tärkeää olla tietoinen ympäristöstäsi ja ryhtyä tarvittaviin varotoimiin,
mutta yleisesti ottaen Suomessa ei tarvitse huolehtia yksin kävelemisestä kaduilla öisin.`;

export default walking_alone;